/**
 * 音频开关（仅当模型 enableAudio 时显示）
 */

import { Volume2, VolumeX } from 'lucide-react';

interface VideoAudioToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export function VideoAudioToggle({ value, onChange }: VideoAudioToggleProps) {
  return (
    <div className="flex items-center justify-between gap-3 px-3 py-2.5 rounded-xl border border-light-border bg-white">
      <div className="flex items-center gap-2">
        {value ? (
          <Volume2 className="w-4 h-4 text-accent-blue" />
        ) : (
          <VolumeX className="w-4 h-4 text-light-muted" />
        )}
        <div>
          <div className="text-sm font-medium text-light-text">生成配音</div>
          <div className="text-xs text-light-muted">由 AI 自动生成与画面匹配的声音</div>
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={value}
        onClick={() => onChange(!value)}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full transition-colors ${
          value ? 'bg-accent-blue' : 'bg-light-border'
        }`}
      >
        <span
          className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform mt-0.5 ${
            value ? 'translate-x-5' : 'translate-x-0.5'
          }`}
        />
      </button>
    </div>
  );
}
